<div class="col-md-12 mt-0 h-100">
    <div class="card border-0 h-100">
        <div class="row">
            <div class="col-lg-6 col-12">
                <h3 class="inner-title px-3 pt-3 pb-2 mb-0" *ngIf="activeTabId !== 'tradingView'">
                    {{ coinName | titlecase }} {{ 'COIN.CHART.TO' | translate }}
                    {{ 'COIN.CHART.USDT' | translate }}
                    {{ 'COIN.CHART.CHART' | translate }}
                </h3>
            </div>
            <div class="col-lg-6 col-12 bitcoin-chart-block">
                <ul
                    class="nav nav-pills mt-2 mb-1 tabview-underline mt-2 me-3 float-end"
                    id="chart-tabs"
                    role="tablist">
                    <li
                        *ngFor="let tab of chartTabs"
                        class="nav-item"
                        role="presentation"
                        (click)="activeTabId = tab.key">
                        <button
                            role="tab"
                            type="button"
                            class="nav-link"
                            [attr.aria-label]="tab.label"
                            [ngClass]="{ active: tab.key === activeTabId }">
                            {{ tab.name | translate }}
                        </button>
                    </li>
                </ul>
            </div>
            <div div class="col-lg-6 col-12 bitcoin-second-tab mt-1" *ngIf="activeTabId !== 'tradingView'">
                <app-time-intervals
                    (timeIntervalEvent)="changeTimeInterval($event)"
                    [activeInterval]="selectedInterval">
                </app-time-intervals>
            </div>
        </div>

        <div class="px-3 pt-3">
            <!-- Price -->
            <div class="tab-content" *ngIf="activeTabId === 'price'">
                <div class="chart-container">
                    <ng-container *ngIf="!isChartError; else chartErrorTemplate">
                        <div
                            echarts
                            [theme]="eChartTheme"
                            [loading]="isChartLoading"
                            [loadingOpts]="eChartLoadTheme"
                            [options]="priceChartOptions"
                            *ngIf="isPriceChartValid; else chartErrorTemplate"></div>
                    </ng-container>
                </div>
            </div>

            <!-- Market Cap -->
            <div class="tab-content" *ngIf="activeTabId === 'marketCap'">
                <div class="chart-container">
                    <ng-container *ngIf="!isChartError; else chartErrorTemplate">
                        <div
                            echarts
                            [theme]="eChartTheme"
                            [options]="mcChartOptions"
                            [loading]="isChartLoading"
                            [loadingOpts]="eChartLoadTheme"
                            *ngIf="isMcChartValid; else chartErrorTemplate"></div>
                    </ng-container>
                </div>
            </div>

            <!-- Trading View -->
            <div class="tab-content" *ngIf="activeTabId === 'tradingView'">
                <app-trading-view-chart></app-trading-view-chart>
            </div>
        </div>
    </div>
</div>

<ng-template #chartErrorTemplate>
    <div class="error-container">
        <div>{{ 'COIN.CHART.ERROR.SOMETHING_WAS_UNPLUGGED' | translate }}</div>
        <div>{{ 'COIN.CHART.ERROR.THANK_YOU_FOR_YOUR_PATIENCE' | translate }}</div>
    </div>
</ng-template>
